module.exports = __webpack_public_path__ + "1724b781f780d4a08b30f797b023e7c8.svg";